import React, { useState, useRef } from 'react';
import Avatar from '@mui/material/Avatar';
import api from 'api';
import ReactLoading from 'react-loading';
import Cookies from 'js-cookie';
import { Container, Form } from './styles';
import { toast } from 'react-toastify';
import { primary } from 'styles/colorProvider';

function ChangePhoto({ userData: initialUserData }) {
  const fileInputRef = useRef();

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(initialUserData);

  const handleChangePhoto = async (e) => {
    setLoading(true);

    try {
      const ext = e?.target?.files[0]?.name.replaceAll(' ', '').toLowerCase().split('.').pop();

      const formData = new FormData();
      formData.append('filePicture', e?.target?.files[0]);
      formData.append('key', `users/${userData?.cpf}/${new Date().getTime()}.${ext}`);

      const response = await api({
        method: 'POST',
        url: `/upload-and-update-image/${userData?.id}`,
        headers: {
          Authorization: Cookies.get('splitriskwl-authtoken'),
        },
        data: formData,
      });

      const fileUrl = response?.data?.picture;
      const signedUrl = response?.data?.signedUrl;

      setUserData({ ...userData, picture: fileUrl, signedUrl });

      toast.success('Foto de perfil alterada com sucesso!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.error || 'Erro ao alterar a foto', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }
  };

  return (
    <Container>
      <Form>
        <Avatar src={userData?.signedUrl} alt={'userData?.name'} sx={{ width: 160, height: 160 }} style={{ marginRight: 9 }} />
        <input
          style={{ display: 'none' }}
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={(e) => handleChangePhoto(e)}
          disabled={loading}
        />
        <button
          disabled={loading}
          onClick={(e) => {
            e.preventDefault();
            fileInputRef.current.click();
          }}
        >
          {loading ? <ReactLoading color={primary} height={24} width={24} type="spin" /> : 'Alterar foto de perfil'}
        </button>
      </Form>
    </Container>
  );
}

export default ChangePhoto;
